import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewCountryReport = () => { 
    return useQuery({ 
        queryKey: ['viewCountryReport'], 
        queryFn: async () => { 
            const res = await api.get('/reports/distributor-users-countrywise', {
            }); 
            return res.data?.data; 
        }
     });
};  